module.exports = __webpack_public_path__ + "images/ic-minus.svg";